var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTripadvisorSearchScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 19.56772,
    y1: 18.46775,
    x2: 82.53269,
    y2: 83.70856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a6e0bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34841,
    stopColor: "#55e0a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#34e0a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#348b7f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.10583,40.89777c-2.52648,0-4.57268,2.0462-4.57268,4.5728,0,2.52643,2.0462,4.57268,4.57268,4.57268s4.57268-2.04626,4.57268-4.57268c0-2.5266-2.04626-4.57675-4.57268-4.5728Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.80005,31.35409h-9.35237c-4.68203-3.1982-10.33644-5.06088-16.4516-5.06088-6.10743,0-11.74608,1.86669-16.42038,5.06088h-9.37574l4.21732,4.58832c-2.58502,2.35854-4.20558,5.75596-4.20558,9.52817,0,7.1187,5.7716,12.89018,12.8903,12.89018,3.38173,0,6.46268-1.3042,8.76274-3.43637l4.1314,4.49856,4.13146-4.49461c2.10025,1.94688,4.85168,3.18758,7.88802,3.3907v2.61606h-1.84084v12.77169h5.80117v-12.77169h-2.02666v-2.62804c6.62106-.5419,11.83519-6.07657,11.83519-12.83648.00378-3.77615-1.61666-7.1734-4.2018-9.52817l4.21738-4.58832ZM37.10583,54.19419c-4.81876,0-8.72361-3.90486-8.72361-8.72361s3.90492-8.72373,8.72361-8.72373,8.72361,3.90492,8.72361,8.72373-3.90492,8.72361-8.72361,8.72361ZM49.99997,45.21671c0-5.74033-4.17436-10.66837-9.68425-12.77316,2.97945-1.24572,6.24788-1.93691,9.68035-1.93691s6.70468.69119,9.68425,1.93691c-5.50588,2.10875-9.68035,7.0329-9.68035,12.77316ZM71.61394,45.47057c0,4.81876-3.90498,8.72361-8.72361,8.72361s-8.72373-3.90486-8.72373-8.72361,3.90492-8.72373,8.72373-8.72373,8.72361,3.90492,8.72361,8.72373Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.20223,44.90838h1.93366c0-1.67826,1.36527-3.04401,3.04401-3.04401v-1.93366c-2.74471,0-4.97767,2.23297-4.97767,4.97767Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTripadvisorSearchScraper);
export default __webpack_public_path__ + "static/media/tripadvisor-search-scraper.7d43813106a5c2a90f3f479694a42020.svg";
export { ForwardRef as ReactComponent };